import styled from '@emotion/styled';
import {Button} from '@travel-frontend/ui-components';

export const DiscountCampaignBanner = styled(Button)`
  background-color: ${({theme}) => theme.colors.backgroundBrand};
  padding: 8px 12px;
  height: 26px;
  border-radius: 2px;

  &:hover:not(:disabled),
  &:focus {
    background-color: ${({theme}) => theme.colors.backgroundBrandDark};
  }
`;
